import { AxiosResponse } from 'axios';
import { Request } from '../../api';
import { SimplePaginateResponse } from '../../app.types';
import { UserData } from '../../utils';

interface GetUsersParams {
    'filter[name]'?: string;
    'filter[email]'?: string;
    'filter[user_name]'?: string;
    'filter[organization_uuid]'?: string;
    perPage?: number;
}

const adminGetAllUsers = (
    filters: { name?: string; email?: string; userName?: string; organizationUuid?: string },
    perPage?: number,
): Promise<AxiosResponse<SimplePaginateResponse<UserData>>> => {
    const params: GetUsersParams = {};

    if (filters.name) {
        params['filter[name]'] = filters.name;
    }
    if (filters.email) {
        params['filter[email]'] = filters.email;
    }
    if (filters.userName) {
        params['filter[user_name]'] = filters.userName;
    }
    if (filters.organizationUuid) {
        params['filter[organization_uuid]'] = filters.organizationUuid;
    }
    if (perPage) {
        params.perPage = perPage;
    }

    return Request.get('/admin/users', {
        params,
    });
};

interface CreateUserParams {
    first_name: string;
    last_name: string;
    user_name: string;
    email: string;
    phone?: string;
    password: string;
}

const adminCreateUser = (params: CreateUserParams): Promise<AxiosResponse<any>> => {
    return Request.post('/admin/users', params);
};

const adminSearchUsers = (
    search: string,
    perPage = 25,
): Promise<AxiosResponse<SimplePaginateResponse<UserData>>> => {
    return Request.get('/admin/users', {
        params: {
            'filter[search]': search,
            perPage,
        },
    });
};

interface UserIndividualSummary {
    uuid: string;
    name: string;
    organization_uuid: string | null;
    organization_name: string | null;
    profile_photo: string | null;
}

interface UserDetail {
    user: UserData;
    stripe_customer_id: string | null;
    individuals: UserIndividualSummary[];
}

const adminGetUser = (uuid: string): Promise<AxiosResponse<UserDetail>> => {
    return Request.get(`/admin/users/${uuid}`);
};

interface UpdateUserParams {
    email: string;
    phone?: string;
}

const adminUpdateUser = (
    uuid: string,
    params: UpdateUserParams,
): Promise<AxiosResponse<{ user: UserData; message: string }>> => {
    return Request.put(`/admin/users/${uuid}`, params);
};

export { adminGetAllUsers, adminCreateUser, adminSearchUsers, adminGetUser, adminUpdateUser };
export type { CreateUserParams, UserDetail, UserIndividualSummary, UpdateUserParams };
